<div class="card">
  <div>
    <header class="mb-5">
      <h4><strong>Add Vendor Black / Legal</strong></h4>
    </header>
    <div class="p-formgrid grid">
      <!-- <div class="field col feild-bg" ></div> -->
      <div class="field col feild-bg" >
        <label for="Company_Title"><strong>Vendor Name</strong>&nbsp;&nbsp;&nbsp;</label>
        <p-dropdown id="Company_Title" [options]="vendor_list" [virtualScroll]="true" [virtualScrollItemSize]="20" [filter]="true" [showClear]="true" filterBy="business_name"  optionLabel="business_name" optionValue="get_user" [(ngModel)]="vendor"
          placeholder="Select an Option" [style]='{"width": "100%"}'></p-dropdown>
      </div>
      <div class="field col feild-bg">
        <label for="short_name"><strong>Remark</strong>&nbsp;&nbsp;&nbsp;</label>
        <input pInputText [(ngModel)]="black_list_remark" style="width:100%"/>
      </div>
      <!-- <div class="field col feild-bg" ></div> -->
    </div>
    <div class="p-formgrid grid">
      <div class="field col feild-bg">
        <label for="Company_Title"><strong>Black List</strong>&nbsp;&nbsp;&nbsp;</label>
        <p-checkbox
        [(ngModel)]="is_black_list"
        [binary]="true"
        inputId="binary"
        [ngStyle]="{'transform': 'scale(1.2)', 'margin-left': '30px'}"
         />
        <!-- <p-radioButton name="black_list" [(ngModel)]="is_black_list" value="YES" inputId="ingredient1" /> -->
      </div>
      <div class="field col feild-bg">
        <label for="short_name"><strong>Legal Case</strong>&nbsp;&nbsp;&nbsp;</label>
        <p-checkbox
        [(ngModel)]="is_legal_case"
        [binary]="true"
        inputId="binary"
        [ngStyle]="{'transform': 'scale(1.2)','margin-left': '30px'}"
         />
        <!-- <p-radioButton name="legal_case" [(ngModel)]="is_legal_case" value="YES" inputId="ingredient2" /> -->
      </div>
      <div class="field col feild-bg" ></div>
      <div class="field col feild-bg" ></div>
    </div>
    <div style="display: flex; justify-content: center; align-items: center">
      <button pButton type="button" style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 70px;
        " pTooltip="Are You Sure You Want To Submit!" label="Submit" [disabled]="!vendor || !is_black_list && !is_legal_case" (click)="onSubmit()"></button>
    </div>
  </div>
</div>
<p-toast></p-toast>
